import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonReportItem } from 'src/modules/motor-credito/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

export type EnderecoProps = {
    person: PersonReportItem
}

export default function Endereco({ person }: EnderecoProps) {
    if (!person.registration.address) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Endereço</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Endereço" value={person.registration.address.addressLine || '-'} xs={12} />
                <GridItem label="Bairro" value={person.registration.address.district || '-'} xs={6} />
                <GridItem label="Cidade" value={person.registration.address.city || '-'} xs={6} />
                <GridItem label="Uf" value={person.registration.address.state || '-'} xs={6} />
                <GridItem label="CEP" value={person.registration.address.zipCode || '-'} xs={6} />
            </Grid>

            <Divider textAlign="center">Histórico de Endereços</Divider>

            {person.registration.addresses?.map((address, index) => (
                <Grid
                    key={index}
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <GridItem
                        label="Data Atualização"
                        value={address.updateDate ? formatDateNoTz(address.updateDate) : '-'}
                        xs={12}
                    />
                    <GridItem label="Tipo" value={address.addressTypeDescription || '-'} xs={12} />
                    <GridItem label="Endereço" value={address.addressLine || '-'} xs={12} />
                    <GridItem label="Número" value={address.addressNumber || '-'} xs={12} />
                    <GridItem label="Bairro" value={address.district || '-'} xs={6} />
                    <GridItem label="Cidade" value={address.city || '-'} xs={6} />
                    <GridItem label="Complemento" value={address.addressComplement || '-'} xs={12} />
                    <GridItem label="Uf" value={address.state || '-'} xs={6} />
                    <GridItem label="CEP" value={address.zipCode || '-'} xs={6} />
                </Grid>
            ))}
        </>
    )
}
